import * as React from 'react'

function SvgCimb(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width="60"
      height="35"
      viewBox="0 0 60 35"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g clipPath="url(#clip0_209_121497)">
        <path
          d="M29.0943 20.0948C28.5657 20.5141 27.9295 20.7758 27.2589 20.85C26.5882 20.9242 25.9103 20.8078 25.3028 20.5142C24.6952 20.2206 24.1828 19.7617 23.8242 19.1902C23.4656 18.6186 23.2754 17.9576 23.2754 17.2828C23.2754 16.6081 23.4656 15.947 23.8242 15.3755C24.1828 14.8039 24.6952 14.3451 25.3028 14.0515C25.9103 13.7579 26.5882 13.6415 27.2589 13.7157C27.9295 13.7899 28.5657 14.0516 29.0943 14.4708L29.1226 14.4972L30.652 12.9711L30.616 12.9395C29.5757 12.0347 28.2436 11.5362 26.8649 11.5356C25.9371 11.5346 25.0228 11.7582 24.2002 12.1873C23.3775 12.6164 22.671 13.2382 22.1409 13.9997C21.6108 14.7612 21.2729 15.6397 21.1561 16.5601C21.0393 17.4806 21.147 18.4156 21.4701 19.2854C21.7932 20.1551 22.322 20.9338 23.0114 21.5547C23.7008 22.1757 24.5302 22.6206 25.4289 22.8513C26.3276 23.0821 27.2687 23.0919 28.172 22.8799C29.0753 22.6679 29.9138 22.2404 30.616 21.6339L30.652 21.5972L29.1226 20.0697L29.0943 20.0942V20.0948ZM32.7231 22.7096H34.9223V11.8535H32.7231V22.7096ZM43.5818 18.7913C43.5008 18.6472 39.7478 11.8342 39.7478 11.8342H37.6053V22.691H39.7928V16.2067L43.5786 22.7785L47.3464 16.2067V22.691H49.534V11.8355H47.3882C47.3882 11.8355 43.6565 18.6485 43.5761 18.7926L43.5818 18.7913ZM58.5712 17.1474C58.9596 16.9214 59.2817 16.5973 59.5054 16.2076C59.7291 15.8179 59.8465 15.3763 59.8458 14.927C59.8458 13.0322 58.5513 11.8567 56.4711 11.8567H52.1018V22.7103H56.6513C58.7102 22.7103 59.997 21.5084 59.997 19.566C60.0222 19.0676 59.9005 18.5728 59.6472 18.1429C59.3939 17.713 59.02 17.3669 58.5718 17.1474H58.5712ZM54.2964 13.821H56.3103C57.1467 13.821 57.6524 14.2675 57.6524 15.0164C57.6524 15.7654 57.148 16.2087 56.3103 16.2087H54.299L54.2964 13.821ZM56.4422 20.7466H54.299V18.191H56.4448C56.6194 18.1799 56.7944 18.2047 56.9591 18.2639C57.1238 18.3231 57.2745 18.4155 57.4021 18.5352C57.5297 18.6549 57.6314 18.7996 57.7009 18.9601C57.7704 19.1207 57.8063 19.2938 57.8063 19.4688C57.8063 19.6438 57.7704 19.8169 57.7009 19.9775C57.6314 20.138 57.5297 20.2827 57.4021 20.4024C57.2745 20.5222 57.1238 20.6145 56.9591 20.6737C56.7944 20.7329 56.6194 20.7577 56.4448 20.7466"
          fill="#700019"
        />
        <path d="M16.5657 9H0V25.5689H16.5657V9Z" fill="#700019" />
        <path
          d="M10.7337 12.1313H1.92871L5.82516 17.2831H14.634L10.7337 12.1313Z"
          fill="white"
        />
        <path
          d="M14.6331 17.2832H5.82486L1.92969 22.4394H10.7334L14.6331 17.2832Z"
          fill="#E50019"
        />
      </g>
      <defs>
        <clipPath id="clip0_209_121497">
          <rect width="60" height="35" fill="white" />
        </clipPath>
      </defs>
    </svg>
  )
}

export default SvgCimb
